// import React, { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import { api } from "./../../App";
// import { encryptPayload, decryptResponse } from "./../CryptoUtil";

// const DEFAULT_SM = "SM1000";
// const DEFAULT_ASM = "ASM1000";
// const clean = (v) => String(v ?? "").trim();
// const norm = (v) => clean(v).toLowerCase();
// const getId = (r, kind) => clean(r?.[`${kind}_id`] ?? r?.id ?? r?.code);
// const getName = (r) => clean(r?.name ?? r?.full_name ?? r?.username);

// function sessionHeaders() {
//   let session = null;
//   try { session = JSON.parse(localStorage.getItem("userSession") || "null"); } catch { /* no session */ }
//   return {
//     Accept: "application/json",
//     ...(session?.token ? { Authorization: `Bearer ${session.token}` } : {}),
//   };
// }

// function decode(raw) {
//   if (raw?.encrypted?.payload !== undefined) {
//     return decryptResponse(raw.encrypted.payload, raw.encrypted.transactionId);
//   }
//   if (raw?.payload !== undefined && raw?.transactionId) {
//     return decryptResponse(raw.payload, raw.transactionId);
//   }
//   return raw;
// }

// function records(raw, keys) {
//   const data = decode(raw);
//   for (const value of [data, data?.data, data?.result]) {
//     if (Array.isArray(value)) return value;
//     for (const key of [...keys, "records", "list", "items", "data"]) {
//       if (Array.isArray(value?.[key])) return value[key];
//     }
//   }
//   return [];
// }

// function parseArea(raw) {
//   if (!raw) return {};
//   if (typeof raw === "object") return raw;
//   try { return JSON.parse(raw); } catch { return {}; }
// }

// // Normalize common working_area formats into State > District > Cities.
// function areaMap(record) {
//   const raw = parseArea(record?.working_area_new ?? record?.working_area ?? record?.working_states);
//   const result = {};
//   const add = (state, district = "*", cities = ["*"]) => {
//     const s = norm(state);
//     const d = norm(district) || "*";
//     if (!s) return;
//     result[s] ??= {};
//     result[s][d] ??= new Set();
//     cities.forEach((city) => result[s][d].add(norm(city) || "*"));
//   };
//   const readDistricts = (state, value) => {
//     if (value == null || value === true || norm(value) === "all") { add(state); return; }
//     if (Array.isArray(value)) {
//       value.forEach((entry) => {
//         if (typeof entry === "string") add(state, entry);
//         else if (entry && typeof entry === "object") {
//           const district = entry.district ?? entry.name;
//           const cities = entry.cities ?? entry.tehsils ?? entry.city ?? entry.tehsil;
//           add(state, district, Array.isArray(cities) ? cities.map((c) => typeof c === "string" ? c : c.name ?? c.city ?? c.tehsil) : ["*"]);
//         }
//       });
//     } else if (typeof value === "object") {
//       Object.entries(value).forEach(([district, cities]) => {
//         if (Array.isArray(cities)) add(state, district, cities.map((c) => typeof c === "string" ? c : c.name ?? c.city ?? c.tehsil));
//         else if (cities && typeof cities === "object") add(state, district, Object.keys(cities));
//         else add(state, district);
//       });
//     }
//   };
//   if (Array.isArray(raw)) {
//     raw.forEach((entry) => {
//       if (typeof entry === "string") add(entry);
//       else if (entry && typeof entry === "object") readDistricts(entry.state ?? entry.state_name ?? entry.name, entry.districts ?? entry.working_area);
//     });
//   } else if (raw && typeof raw === "object") {
//     Object.entries(raw).forEach(([state, districts]) => readDistricts(state, districts));
//   }
//   return result;
// }

// function areaText(record) {
//   const map = areaMap(record);
//   const names = [];
//   Object.entries(map).forEach(([state, districts]) => {
//     names.push(state);
//     Object.entries(districts).forEach(([district, cities]) => {
//       if (district !== "*") names.push(district);
//       cities.forEach((city) => { if (city !== "*") names.push(city); });
//     });
//   });
//   return [...new Set(names)].join(", ");
// }

// function compatible(sm, asm) {
//   const smMap = areaMap(sm);
//   const asmMap = areaMap(asm);
//   if (!Object.keys(smMap).length || !Object.keys(asmMap).length) return false;
//   // Every SM-covered city/district must be inside the destination ASM's coverage.
//   return Object.entries(smMap).every(([state, districts]) => {
//     const target = asmMap[state];
//     if (!target) return false;
//     if (target["*"]?.has("*")) return true;
//     return Object.entries(districts).every(([district, cities]) => {
//       const allowed = target[district] ?? target["*"];
//       if (!allowed) return false;
//       if (allowed.has("*")) return true;
//       if (district === "*" || cities.has("*")) return false;
//       return [...cities].every((city) => allowed.has(city));
//     });
//   });
// }

// // Find the district/city matching the SM search, not just its state.
// function searchedPlaces(sm, search) {
//   const term = norm(search);
//   if (!term) return [];
//   const places = [];
//   Object.entries(areaMap(sm)).forEach(([state, districts]) => {
//     Object.entries(districts).forEach(([district, cities]) => {
//       const cityMatches = [...cities].filter((city) => city !== "*" && city.includes(term));
//       if (cityMatches.length) {
//         cityMatches.forEach((city) => places.push({ state, district, city }));
//       } else if (district !== "*" && district.includes(term)) {
//         places.push({ state, district, city: "" });
//       } else if (state.includes(term)) {
//         places.push({ state, district: "", city: "" });
//       }
//     });
//   });
//   return places;
// }

// // An ASM assigned to MP alone must not match an Itarsi-specific search.
// function asmCoversSearchedPlace(asm, place) {
//   const stateArea = areaMap(asm)[place.state];
//   if (!stateArea) return false;
//   if (!place.district) return true;
//   const districtCities = stateArea[place.district];
//   if (!districtCities) return false;
//   if (!place.city) return true;
//   return districtCities.has("*") || districtCities.has(place.city);
// }

// function apiError(error) {
//   try { return decode(error.response?.data)?.message || error.message || "Request failed"; }
//   catch { return error.message || "Request failed"; }
// }

// const SmTransfer = () => {
//   const [sms, setSms] = useState([]);
//   const [asms, setAsms] = useState([]);
//   const [query, setQuery] = useState("");
//   const [asmQuery, setAsmQuery] = useState("");
//   const [selected, setSelected] = useState([]);
//   const [chosenAsm, setChosenAsm] = useState("");
//   const [modalOpen, setModalOpen] = useState(false);
//   const [transferIds, setTransferIds] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState("");
//   const [message, setMessage] = useState("");

//   const loadSms = async () => {
//     const response = await axios.get(`${api.replace(/\/?$/, "/")}getSm.php`, {
//       withCredentials: true, headers: sessionHeaders(), timeout: 20000,
//     });
//     const payload = decode(response.data);
//     if (payload?.success === false) throw new Error(payload.message || "Cannot load SMs");
//     return records(response.data, ["sms", "sm"])
//       .filter((sm) => getId(sm, "sm") && norm(getId(sm, "sm")) !== norm(DEFAULT_SM))
//       .filter((sm) => !["inactive", "deleted", "disabled"].includes(norm(sm.status)));
//   };

//   const loadAsms = async (smRows) => {
//     const zsmIds = [...new Set(smRows.map((sm) => clean(sm.zsm_id)).filter(Boolean))];
//     const responses = await Promise.allSettled(zsmIds.map((zsmId) =>
//       axios.get(`${api.replace(/\/?$/, "/")}getAsm.php`, {
//         params: { zsm_id: zsmId }, withCredentials: true,
//         headers: sessionHeaders(), timeout: 20000,
//       })
//     ));
//     const result = new Map();
//     responses.forEach((response) => {
//       if (response.status !== "fulfilled") return;
//       records(response.value.data, ["asms", "asm"]).forEach((asm) => {
//         const id = getId(asm, "asm");
//         if (id && norm(id) !== norm(DEFAULT_ASM) && !["inactive", "deleted", "disabled"].includes(norm(asm.status))) {
//           result.set(norm(id), asm);
//         }
//       });
//     });
//     if (responses.length && responses.every((r) => r.status === "rejected")) {
//       throw new Error("ASM list could not load. Check getAsm.php.");
//     }
//     return [...result.values()];
//   };

//   useEffect(() => {
//     let alive = true;
//     (async () => {
//       setLoading(true);
//       try {
//         const smRows = await loadSms();
//         const asmRows = await loadAsms(smRows);
//         if (alive) { setSms(smRows); setAsms(asmRows); }
//       } catch (err) { if (alive) setError(apiError(err)); }
//       finally { if (alive) setLoading(false); }
//     })();
//     return () => { alive = false; };
//   }, []);

//   const filtered = useMemo(() => {
//     const term = norm(query);
//     if (!term) return [];
//     return sms.filter((sm) => [getId(sm, "sm"), getName(sm), clean(sm.phone ?? sm.mobile), areaText(sm)]
//       .some((text) => norm(text).includes(term)));
//   }, [sms, query]);

//   const allSelected = filtered.length > 0 && filtered.every((sm) => selected.includes(getId(sm, "sm")));
//   const targetSms = sms.filter((sm) => transferIds.includes(getId(sm, "sm")));
//   const matchingAsms = asms.filter((asm) => {
//     if (!targetSms.length || !targetSms.every((sm) => compatible(sm, asm))) return false;
//     // Narrow ASM results to the searched city/district for each selected SM.
//     const matchesSearchArea = targetSms.every((sm) => {
//       const places = searchedPlaces(sm, query);
//       return places.length === 0 || places.some((place) => asmCoversSearchedPlace(asm, place));
//     });
//     if (!matchesSearchArea) return false;
//     return [getName(asm), getId(asm, "asm"), clean(asm.phone ?? asm.mobile)]
//       .some((value) => norm(value).includes(norm(asmQuery)));
//   });

//   const asmById = useMemo(() => new Map(asms.map((asm) => [norm(getId(asm, "asm")), asm])), [asms]);

//   const openTransfer = (ids) => {
//     setTransferIds(ids);
//     setChosenAsm("");
//     setAsmQuery("");
//     setError("");
//     setModalOpen(true);
//   };

//   const confirmTransfer = async () => {
//     if (!chosenAsm || !transferIds.length) return;
//     setSaving(true);
//     setError("");
//     try {
//       const encrypted = encryptPayload({ sm_ids: transferIds, asm_id: chosenAsm });
//       const response = await axios.post(`${api.replace(/\/?$/, "/")}transferSm.php`, encrypted, {
//         withCredentials: true,
//         headers: { ...sessionHeaders(), "Content-Type": "application/json" },
//         timeout: 20000,
//       });
//       const result = decode(response.data);
//       if (result?.success !== true) throw new Error(result?.message || "Transfer failed");
//       setMessage(result.message || "SM transferred successfully");
//       setSelected([]);
//       setModalOpen(false);
//       const smRows = await loadSms();
//       setSms(smRows);
//     } catch (err) { setError(apiError(err)); }
//     finally { setSaving(false); }
//   };

//   return (
//     <div className="container-fluid py-4">
//       <div className="d-flex justify-content-between align-items-start mb-4">
//         <div>
//           <h2 className="fw-bold mb-1">SM Transfer</h2>
//           <p className="text-secondary mb-0">Search SM by area, state, district or city and transfer to a compatible ASM.</p>
//         </div>
//       </div>

//       {error && <div className="alert alert-danger" role="alert">{error}</div>}
//       {message && <div className="alert alert-success" role="status">{message}</div>}

//       <div className="card rounded-4 border mb-4">
//         <div className="card-body p-4">
//           <label className="form-label fw-semibold" htmlFor="sm-area-search">Search SM</label>
//           <input id="sm-area-search" className="form-control" value={query}
//             onChange={(e) => { setQuery(e.target.value); setSelected([]); }}
//             placeholder="Search SM by area, state, city, district, name or phone number" />
//         </div>
//       </div>

//       <div className="card rounded-4 border">
//         <div className="card-body p-3 p-md-4">
//           <div className="d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">
//             <h5 className="fw-bold mb-0">SM List {query.trim() ? `(${filtered.length})` : ""}</h5>
//             <button type="button" className="btn btn-primary" disabled={!selected.length}
//               onClick={() => openTransfer(selected)}>Transfer Selected ({selected.length})</button>
//           </div>
//           <div className="table-responsive">
//             <table className="table table-hover align-middle">
//               <thead className="table-light">
//                 <tr>
//                   <th><input type="checkbox" className="form-check-input" aria-label="Select all matching SMs"
//                     checked={allSelected} disabled={!filtered.length}
//                     onChange={(e) => setSelected(e.target.checked ? filtered.map((sm) => getId(sm, "sm")) : [])} /></th>
//                   <th>SM ID</th><th>SM Name</th><th>Phone</th><th>Current ASM</th><th>Working Area</th><th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((sm) => {
//                   const id = getId(sm, "sm");
//                   return (
//                     <tr key={id}>
//                       <td><input type="checkbox" className="form-check-input" aria-label={`Select ${getName(sm) || id}`}
//                         checked={selected.includes(id)} onChange={(e) => setSelected((old) => e.target.checked ? [...old, id] : old.filter((x) => x !== id))} /></td>
//                       <td>{id}</td><td>{getName(sm) || "—"}</td><td>{sm.phone ?? sm.mobile ?? "—"}</td>
//                       <td>
//                         <div className="fw-semibold">{getName(asmById.get(norm(sm.asm_id))) || sm.asm_name || "Unknown ASM"}</div>
//                         <small className="text-secondary">{sm.asm_id || "Not assigned"}</small>
//                       </td><td style={{ minWidth: 220 }}>{areaText(sm) || "No area data"}</td>
//                       <td><button type="button" className="btn btn-sm btn-outline-primary" onClick={() => openTransfer([id])}>Transfer</button></td>
//                     </tr>
//                   );
//                 })}
//                 {!loading && !query.trim() && <tr><td colSpan="7" className="text-center text-secondary py-4">Search an area, state, district or city to see SMs.</td></tr>}
//                 {!loading && query.trim() && !filtered.length && <tr><td colSpan="7" className="text-center text-secondary py-4">No matching SM found.</td></tr>}
//                 {loading && <tr><td colSpan="7" className="text-center py-4">Loading SMs...</td></tr>}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {modalOpen && (
//         <div className="modal d-block" tabIndex={-1} role="dialog" aria-modal="true" aria-label="Transfer SM" style={{ background: "rgba(0,0,0,.55)" }}>
//           <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
//             <div className="modal-content rounded-4">
//               <div className="modal-header">
//                 <h5 className="modal-title fw-bold">Transfer {transferIds.length} SM(s) to ASM</h5>
//                 <button type="button" className="btn-close" aria-label="Close" disabled={saving} onClick={() => setModalOpen(false)} />
//               </div>
//               <div className="modal-body">
//                 <p className="text-secondary small">Only ASMs covering the searched district/city and every selected SM working area are listed. State-only matches are excluded for city searches.</p>
//                 <input className="form-control mb-3" placeholder="Search ASM by name or phone number"
//                   value={asmQuery} onChange={(e) => setAsmQuery(e.target.value)} />
//                 <div className="table-responsive">
//                   <table className="table table-hover align-middle">
//                     <thead className="table-light"><tr><th>Select</th><th>ASM ID</th><th>ASM Name</th><th>Phone</th><th>Working Area</th></tr></thead>
//                     <tbody>
//                       {matchingAsms.map((asm) => {
//                         const id = getId(asm, "asm");
//                         return <tr key={id} onClick={() => setChosenAsm(id)} style={{ cursor: "pointer" }}>
//                           <td><input type="radio" className="form-check-input" name="targetAsm" checked={chosenAsm === id}
//                             onChange={() => setChosenAsm(id)} aria-label={`Select ${getName(asm) || id}`} /></td>
//                           <td>{id}</td><td>{getName(asm) || "—"}</td><td>{asm.phone ?? asm.mobile ?? "—"}</td>
//                           <td>{areaText(asm) || "—"}</td>
//                         </tr>;
//                       })}
//                       {!matchingAsms.length && <tr><td colSpan="5" className="text-center text-secondary py-4">No ASM covers the searched district/city and all selected SM working areas.</td></tr>}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button type="button" className="btn btn-light" disabled={saving} onClick={() => setModalOpen(false)}>Cancel</button>
//                 <button type="button" className="btn btn-primary" disabled={!chosenAsm || saving} onClick={confirmTransfer}>
//                   {saving ? "Transferring..." : "Confirm Transfer"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SmTransfer;

import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { api } from "./../../App";
import { encryptPayload, decryptResponse } from "./../CryptoUtil";

const DEFAULT_SM = "SM1000";
const DEFAULT_ASM = "ASM1000";
const clean = (v) => String(v ?? "").trim();
const norm = (v) => clean(v).toLowerCase();
const getId = (r, kind) => clean(r?.[`${kind}_id`] ?? r?.id ?? r?.code);
const getName = (r) => clean(r?.name ?? r?.full_name ?? r?.username);

function sessionHeaders() {
  let session = null;
  try { session = JSON.parse(localStorage.getItem("userSession") || "null"); } catch { /* no session */ }
  return {
    Accept: "application/json",
    ...(session?.token ? { Authorization: `Bearer ${session.token}` } : {}),
  };
}

function decode(raw) {
  if (raw?.encrypted?.payload !== undefined) {
    return decryptResponse(raw.encrypted.payload, raw.encrypted.transactionId);
  }
  if (raw?.payload !== undefined && raw?.transactionId) {
    return decryptResponse(raw.payload, raw.transactionId);
  }
  return raw;
}

function records(raw, keys) {
  const data = decode(raw);
  for (const value of [data, data?.data, data?.result]) {
    if (Array.isArray(value)) return value;
    for (const key of [...keys, "records", "list", "items", "data"]) {
      if (Array.isArray(value?.[key])) return value[key];
    }
  }
  return [];
}

function parseArea(raw) {
  if (!raw) return {};
  if (typeof raw === "object") return raw;
  try { return JSON.parse(raw); } catch { return {}; }
}

// Normalize common working_area formats into State > District > Cities.
function areaMap(record) {
  const raw = parseArea(record?.working_area_new ?? record?.working_area ?? record?.working_states);
  const result = {};
  const add = (state, district = "*", cities = ["*"]) => {
    const s = norm(state);
    const d = norm(district) || "*";
    if (!s) return;
    result[s] ??= {};
    result[s][d] ??= new Set();
    cities.forEach((city) => result[s][d].add(norm(city) || "*"));
  };
  const readDistricts = (state, value) => {
    if (value == null || value === true || norm(value) === "all") { add(state); return; }
    if (Array.isArray(value)) {
      value.forEach((entry) => {
        if (typeof entry === "string") add(state, entry);
        else if (entry && typeof entry === "object") {
          const district = entry.district ?? entry.name;
          const cities = entry.cities ?? entry.tehsils ?? entry.city ?? entry.tehsil;
          add(state, district, Array.isArray(cities) ? cities.map((c) => typeof c === "string" ? c : c.name ?? c.city ?? c.tehsil) : ["*"]);
        }
      });
    } else if (typeof value === "object") {
      Object.entries(value).forEach(([district, cities]) => {
        if (Array.isArray(cities)) add(state, district, cities.map((c) => typeof c === "string" ? c : c.name ?? c.city ?? c.tehsil));
        else if (cities && typeof cities === "object") add(state, district, Object.keys(cities));
        else add(state, district);
      });
    }
  };
  if (Array.isArray(raw)) {
    raw.forEach((entry) => {
      if (typeof entry === "string") add(entry);
      else if (entry && typeof entry === "object") readDistricts(entry.state ?? entry.state_name ?? entry.name, entry.districts ?? entry.working_area);
    });
  } else if (raw && typeof raw === "object") {
    Object.entries(raw).forEach(([state, districts]) => readDistricts(state, districts));
  }
  return result;
}

function areaText(record) {
  const map = areaMap(record);
  const names = [];
  Object.entries(map).forEach(([state, districts]) => {
    names.push(state);
    Object.entries(districts).forEach(([district, cities]) => {
      if (district !== "*") names.push(district);
      cities.forEach((city) => { if (city !== "*") names.push(city); });
    });
  });
  return [...new Set(names)].join(", ");
}

function compatible(sm, asm) {
  const smMap = areaMap(sm);
  const asmMap = areaMap(asm);
  if (!Object.keys(smMap).length || !Object.keys(asmMap).length) return false;
  // Every SM-covered city/district must be inside the destination ASM's coverage.
  return Object.entries(smMap).every(([state, districts]) => {
    const target = asmMap[state];
    if (!target) return false;
    if (target["*"]?.has("*")) return true;
    return Object.entries(districts).every(([district, cities]) => {
      const allowed = target[district] ?? target["*"];
      if (!allowed) return false;
      if (allowed.has("*")) return true;
      if (district === "*" || cities.has("*")) return false;
      return [...cities].every((city) => allowed.has(city));
    });
  });
}

// Find the district/city matching the SM search, not just its state.
function searchedPlaces(sm, search) {
  const term = norm(search);
  if (!term) return [];
  const places = [];
  Object.entries(areaMap(sm)).forEach(([state, districts]) => {
    Object.entries(districts).forEach(([district, cities]) => {
      const cityMatches = [...cities].filter((city) => city !== "*" && city.includes(term));
      if (cityMatches.length) {
        cityMatches.forEach((city) => places.push({ state, district, city }));
      } else if (district !== "*" && district.includes(term)) {
        places.push({ state, district, city: "" });
      } else if (state.includes(term)) {
        places.push({ state, district: "", city: "" });
      }
    });
  });
  return places;
}

// An ASM assigned to MP alone must not match an Itarsi-specific search.
function asmCoversSearchedPlace(asm, place) {
  const stateArea = areaMap(asm)[place.state];
  if (!stateArea) return false;
  if (!place.district) return true;
  const districtCities = stateArea[place.district];
  if (!districtCities) return false;
  if (!place.city) return true;
  return districtCities.has("*") || districtCities.has(place.city);
}

function apiError(error) {
  try { return decode(error.response?.data)?.message || error.message || "Request failed"; }
  catch { return error.message || "Request failed"; }
}

const SmTransfer = () => {
  const [sms, setSms] = useState([]);
  const [asms, setAsms] = useState([]);
  const [eligibleAsms, setEligibleAsms] = useState([]);
  const [loadingEligible, setLoadingEligible] = useState(false);
  const [query, setQuery] = useState("");
  const [asmQuery, setAsmQuery] = useState("");
  const [selected, setSelected] = useState([]);
  const [chosenAsm, setChosenAsm] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [transferIds, setTransferIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const loadSms = async () => {
    const response = await axios.get(`${api.replace(/\/?$/, "/")}getSm.php`, {
      withCredentials: true, headers: sessionHeaders(), timeout: 20000,
    });
    const payload = decode(response.data);
    if (payload?.success === false) throw new Error(payload.message || "Cannot load SMs");
    return records(response.data, ["sms", "sm"])
      .filter((sm) => getId(sm, "sm") && norm(getId(sm, "sm")) !== norm(DEFAULT_SM))
      .filter((sm) => !["inactive", "deleted", "disabled"].includes(norm(sm.status)));
  };

  const loadAsms = async (smRows) => {
    const zsmIds = [...new Set(smRows.map((sm) => clean(sm.zsm_id)).filter(Boolean))];
    const responses = await Promise.allSettled(zsmIds.map((zsmId) =>
      axios.get(`${api.replace(/\/?$/, "/")}getAsm.php`, {
        params: { zsm_id: zsmId }, withCredentials: true,
        headers: sessionHeaders(), timeout: 20000,
      })
    ));
    const result = new Map();
    responses.forEach((response) => {
      if (response.status !== "fulfilled") return;
      records(response.value.data, ["asms", "asm"]).forEach((asm) => {
        const id = getId(asm, "asm");
        if (id && norm(id) !== norm(DEFAULT_ASM) && !["inactive", "deleted", "disabled"].includes(norm(asm.status))) {
          result.set(norm(id), asm);
        }
      });
    });
    if (responses.length && responses.every((r) => r.status === "rejected")) {
      throw new Error("ASM list could not load. Check getAsm.php.");
    }
    return [...result.values()];
  };

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const smRows = await loadSms();
        const asmRows = await loadAsms(smRows);
        if (alive) { setSms(smRows); setAsms(asmRows); }
      } catch (err) { if (alive) setError(apiError(err)); }
      finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, []);

  const filtered = useMemo(() => {
    const term = norm(query);
    if (!term) return [];
    return sms.filter((sm) => [getId(sm, "sm"), getName(sm), clean(sm.phone ?? sm.mobile), areaText(sm)]
      .some((text) => norm(text).includes(term)));
  }, [sms, query]);

  const allSelected = filtered.length > 0 && filtered.every((sm) => selected.includes(getId(sm, "sm")));
  const targetSms = sms.filter((sm) => transferIds.includes(getId(sm, "sm")));
  const matchingAsms = eligibleAsms.filter((asm) => {
    return [getName(asm), getId(asm, "asm"), clean(asm.phone ?? asm.mobile)]
      .some((value) => norm(value).includes(norm(asmQuery)));
  });

  const asmById = useMemo(() => new Map(asms.map((asm) => [norm(getId(asm, "asm")), asm])), [asms]);

  const openTransfer = async (ids) => {
    setTransferIds(ids);
    setChosenAsm("");
    setAsmQuery("");
    setError("");
    setEligibleAsms([]);
    setModalOpen(true);
    setLoadingEligible(true);
    try {
      const payload = encryptPayload({ sm_ids: ids, search: query });
      const response = await axios.post(`${api.replace(/\/?$/, "/")}getTransferAsms.php`, payload, {
        withCredentials: true,
        headers: { ...sessionHeaders(), "Content-Type": "application/json" },
        timeout: 20000,
      });
      const result = decode(response.data);
      if (result?.success !== true) throw new Error(result?.message || "ASM search failed");
      setEligibleAsms(result.asms || result.data?.asms || []);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoadingEligible(false);
    }
  };

  const confirmTransfer = async () => {
    if (!chosenAsm || !transferIds.length) return;
    setSaving(true);
    setError("");
    try {
      const encrypted = encryptPayload({ sm_ids: transferIds, asm_id: chosenAsm });
      const response = await axios.post(`${api.replace(/\/?$/, "/")}transferSm.php`, encrypted, {
        withCredentials: true,
        headers: { ...sessionHeaders(), "Content-Type": "application/json" },
        timeout: 20000,
      });
      const result = decode(response.data);
      if (result?.success !== true) throw new Error(result?.message || "Transfer failed");
      setMessage(result.message || "SM transferred successfully");
      setSelected([]);
      setModalOpen(false);
      const smRows = await loadSms();
      setSms(smRows);
    } catch (err) { setError(apiError(err)); }
    finally { setSaving(false); }
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-start mb-4">
        <div>
          <h2 className="fw-bold mb-1">SM Transfer</h2>
          <p className="text-secondary mb-0">Search SM by area, state, district or city and transfer to a compatible ASM.</p>
        </div>
      </div>

      {error && <div className="alert alert-danger" role="alert">{error}</div>}
      {message && <div className="alert alert-success" role="status">{message}</div>}

      <div className="card rounded-4 border mb-4">
        <div className="card-body p-4">
          <label className="form-label fw-semibold" htmlFor="sm-area-search">Search SM</label>
          <input id="sm-area-search" className="form-control" value={query}
            onChange={(e) => { setQuery(e.target.value); setSelected([]); }}
            placeholder="Search SM by area, state, city, district, name or phone number" />
        </div>
      </div>

      <div className="card rounded-4 border">
        <div className="card-body p-3 p-md-4">
          <div className="d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">
            <h5 className="fw-bold mb-0">SM List {query.trim() ? `(${filtered.length})` : ""}</h5>
            <button type="button" className="btn btn-primary" disabled={!selected.length}
              onClick={() => openTransfer(selected)}>Transfer Selected ({selected.length})</button>
          </div>
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th><input type="checkbox" className="form-check-input" aria-label="Select all matching SMs"
                    checked={allSelected} disabled={!filtered.length}
                    onChange={(e) => setSelected(e.target.checked ? filtered.map((sm) => getId(sm, "sm")) : [])} /></th>
                  <th>SM ID</th><th>SM Name</th><th>Phone</th><th>Current ASM</th><th>Working Area</th><th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((sm) => {
                  const id = getId(sm, "sm");
                  return (
                    <tr key={id}>
                      <td><input type="checkbox" className="form-check-input" aria-label={`Select ${getName(sm) || id}`}
                        checked={selected.includes(id)} onChange={(e) => setSelected((old) => e.target.checked ? [...old, id] : old.filter((x) => x !== id))} /></td>
                      <td>{id}</td><td>{getName(sm) || "—"}</td><td>{sm.phone ?? sm.mobile ?? "—"}</td>
                      <td>
                        <div className="fw-semibold">{getName(asmById.get(norm(sm.asm_id))) || sm.asm_name || "Unknown ASM"}</div>
                        <small className="text-secondary">{sm.asm_id || "Not assigned"}</small>
                      </td><td style={{ minWidth: 220 }}>{areaText(sm) || "No area data"}</td>
                      <td><button type="button" className="btn btn-sm btn-outline-primary" onClick={() => openTransfer([id])}>Transfer</button></td>
                    </tr>
                  );
                })}
                {!loading && !query.trim() && <tr><td colSpan="7" className="text-center text-secondary py-4">Search an area, state, district or city to see SMs.</td></tr>}
                {!loading && query.trim() && !filtered.length && <tr><td colSpan="7" className="text-center text-secondary py-4">No matching SM found.</td></tr>}
                {loading && <tr><td colSpan="7" className="text-center py-4">Loading SMs...</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {modalOpen && (
        <div className="modal d-block" tabIndex={-1} role="dialog" aria-modal="true" aria-label="Transfer SM" style={{ background: "rgba(0,0,0,.55)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content rounded-4">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">Transfer {transferIds.length} SM(s) to ASM</h5>
                <button type="button" className="btn-close" aria-label="Close" disabled={saving} onClick={() => setModalOpen(false)} />
              </div>
              <div className="modal-body">
                <p className="text-secondary small">ASMs are matched by state and district on the server. For example, Itarsi matches Hoshangabad (Narmadapuram) district.</p>
                <input className="form-control mb-3" placeholder="Search ASM by name or phone number"
                  value={asmQuery} onChange={(e) => setAsmQuery(e.target.value)} />
                <div className="table-responsive">
                  <table className="table table-hover align-middle">
                    <thead className="table-light"><tr><th>Select</th><th>ASM ID</th><th>ASM Name</th><th>Phone</th><th>Working Area</th></tr></thead>
                    <tbody>
                      {matchingAsms.map((asm) => {
                        const id = getId(asm, "asm");
                        return <tr key={id} onClick={() => setChosenAsm(id)} style={{ cursor: "pointer" }}>
                          <td><input type="radio" className="form-check-input" name="targetAsm" checked={chosenAsm === id}
                            onChange={() => setChosenAsm(id)} aria-label={`Select ${getName(asm) || id}`} /></td>
                          <td>{id}</td><td>{getName(asm) || "—"}</td><td>{asm.phone ?? asm.mobile ?? "—"}</td>
                          <td>{areaText(asm) || "—"}</td>
                        </tr>;
                      })}
                      {loadingEligible && <tr><td colSpan="5" className="text-center py-4">Loading district-matched ASMs...</td></tr>}
                      {!loadingEligible && !matchingAsms.length && <tr><td colSpan="5" className="text-center text-secondary py-4">No ASM assigned to the selected SM district.</td></tr>}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" disabled={saving} onClick={() => setModalOpen(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" disabled={!chosenAsm || saving} onClick={confirmTransfer}>
                  {saving ? "Transferring..." : "Confirm Transfer"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SmTransfer;

